import {
 baseAPI,
 baseTransformResponse,
 baseTransformResponse2,
} from 'api/baseApi'
import { ApiResponce } from 'types'
import {
 FubData,
 TAddFubInput,
 TAddTwilioInput,
 TIntegrationFBPages,
 TIntegrationItem,
 TwilioData,
} from '../types'

export const settingApi = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  integration: query<TIntegrationItem[], void>({
   query: (body) => ({
    url: 'user/integration',
    method: 'get',
    body,
   }),
   providesTags: ['FB-INT_LIST'],
   transformResponse: (res: ApiResponce) => res.data,
  }),
  getTwilioList: query<TwilioData, void>({
   query: (body) => ({
    url: 'user/twilio-integration',
    method: 'get',
    body,
   }),
   providesTags: ['TWL-INT_DTLS'],
   transformResponse: (res: ApiResponce) => res.data,
  }),
  fbPages: mutation<void, TIntegrationFBPages>({
   query: (body) => ({
    url: 'user/facebook/pages',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse2,
  }),
  twilioIntegrationStore: mutation<void, TAddTwilioInput>({
   query: (body) => ({
    url: 'user/twilio-integration-store',
    method: 'post',
    body,
   }),
   invalidatesTags: ['GET_MY_PROFILE', 'GLOBAL_SETTINGS', 'TWL-INT_DTLS'],
   transformResponse: baseTransformResponse2,
   onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
    const patchResult = dispatch(
     settingApi.util.updateQueryData('getTwilioList', undefined, (draft) => {
      Object.assign(draft, arg)
     }),
    )
    try {
     await queryFulfilled
    } catch {
     patchResult.undo()
    }
   },
  }),
  unlinkFbPage: mutation<void, { page_id?: string; type?: 'multiple' }>({
   query: (body) => ({
    url: 'user/facebook-page-unlink',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  unlinkTwilioe: mutation<void, void>({
   query: (body) => ({
    url: 'user/twilio-unlink',
    method: 'post',
    body,
   }),
   invalidatesTags: ['GET_MY_PROFILE', 'GLOBAL_SETTINGS'],
   transformResponse: baseTransformResponse,
  }),
  getFubIntegration: query<FubData, void>({
   query: () => ({
    url: 'user/integrations/followupboss/status',
    method: 'get',
   }),
   providesTags: ['FUB-INT_DTLS'],
   transformResponse: (res: ApiResponce) => res.data,
  }),
  fubConnect: mutation<void, TAddFubInput>({
   query: (body) => ({
    url: 'user/integrations/followupboss/connect',
    method: 'post',
    body,
   }),
   invalidatesTags: ['FUB-INT_DTLS'],
   transformResponse: baseTransformResponse2,
  }),
  fubUpdate: mutation<void, TAddFubInput>({
   query: (body) => ({
    url: 'user/integrations/followupboss/update',
    method: 'put',
    body,
   }),
   invalidatesTags: ['FUB-INT_DTLS'],
   transformResponse: baseTransformResponse2,
  }),
  fubTestConnection: mutation<void, void>({
   query: () => ({
    url: 'user/integrations/followupboss/test',
    method: 'post',
   }),
   transformResponse: baseTransformResponse2,
  }),
  fubSync: mutation<void, void>({
   query: () => ({
    url: 'user/integrations/followupboss/sync',
    method: 'post',
   }),
   invalidatesTags: ['FUB-INT_DTLS'],
   transformResponse: baseTransformResponse2,
  }),
  unlinkFub: mutation<void, void>({
   query: () => ({
    url: 'user/integrations/followupboss/disconnect',
    method: 'delete',
   }),
   invalidatesTags: ['FUB-INT_DTLS'],
   transformResponse: baseTransformResponse,
  }),
 }),
})

export const {
 useUnlinkTwilioeMutation,
 useTwilioIntegrationStoreMutation,
 useGetTwilioListQuery,
 useIntegrationQuery,
 useFbPagesMutation,
 useUnlinkFbPageMutation,
 useGetFubIntegrationQuery,
 useFubConnectMutation,
 useFubUpdateMutation,
 useFubTestConnectionMutation,
 useFubSyncMutation,
 useUnlinkFubMutation,
} = settingApi
